import { Component } from "react";
import Energy from "assets/img/energy.jpeg";

class EnergyBlob extends Component {
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  render() {
    return (
      <svg viewBox="0 0 500 500" width="100%" id="blobSvg">
        <defs>
          <clipPath id="shape">
            <path
              id="blob"
              d="M449,307Q427,364,383,404.5Q339,445,280,448Q221,451,169,427Q117,403,67.5,360.5Q18,318,26,252.5Q34,187,65,129.5Q96,72,158,58Q220,44,286.5,34Q353,24,392,79Q431,134,451,192Q471,250,449,307Z"
              fill="#d1d8e0"
            ></path>
          </clipPath>
        </defs>
        <image
          x="0"
          y="0"
          width="100%"
          height="100%"
          clipPath="url(#shape)"
          xlinkHref={Energy}
          preserveAspectRatio="none"
        ></image>
      </svg>
    );
  }
}

export default EnergyBlob;
